import { useEffect, useState } from "react";
import { useLang } from "../../contexts/LanguageContext";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import * as LI from "lucide-react";

// Fallback whitelist — the CMS icon selector will offer these.
export const SERVICE_ICONS = [
  "FileText", "GraduationCap", "Briefcase", "UserSearch",
  "TrendingUp", "Scale", "Users", "Globe2",
  "Building2", "Handshake", "Award", "MessagesSquare",
  "Search", "Compass", "BookOpen", "Landmark",
];

function IconFor(name) {
  return LI[name] || LI.Sparkles;
}

export default function ServicesGrid() {
  const { t, pick } = useLang();
  const [services, setServices] = useState(null);

  useEffect(() => {
    api.get("/home-services").then((r) => setServices(r.data)).catch(() => setServices([]));
  }, []);

  if (services === null) return null; // avoid layout shift while loading
  if (services.length === 0) return null; // hide entire section when all cards deactivated

  return (
    <section className="bg-[#FAFAFA] py-24" data-testid="services-grid">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-3 gap-12 mb-16">
          <div className="lg:col-span-1">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#C8102E] mb-4">
              {t("home.servicesKicker")}
            </p>
            <h2 className="font-serif text-4xl md:text-5xl text-[#0F2040] leading-[1.1] mb-5">
              {t("home.servicesTitle")}
            </h2>
            <p className="text-gray-600 leading-relaxed">{t("home.servicesBody")}</p>
          </div>
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-px bg-gray-200">
            {services.map((s) => {
              const Icon = IconFor(s.icon);
              return (
                <Link
                  key={s.id}
                  to={s.url || "/servicios"}
                  data-testid={`service-card-${s.id}`}
                  className="group bg-white p-8 hover:bg-[#0F2040] transition-colors duration-500"
                >
                  <Icon className="w-8 h-8 text-[#C8102E] group-hover:text-cecit-gold transition-colors mb-5" strokeWidth={1.4} />
                  <h3 className="font-serif text-xl text-[#0F2040] group-hover:text-white transition-colors mb-2">
                    {pick(s, "title")}
                  </h3>
                  <p className="text-sm text-gray-600 group-hover:text-white/70 transition-colors">
                    {pick(s, "description")}
                  </p>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
